import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {userRegister} from "../../services/userRegister";
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {quotesRegister} from "../../services/quotesRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {industriesRegister} from "../../services/industriesRegister";
import {scraperRegister} from "../../services/scraperRegister";
import Typist from "react-typist";
import BoosterHeader from "../../components/booster-header/component";
import queryString from "query-string";
import Carousel from 're-carousel';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import Slider, {Range} from 'rc-slider';
import 'rc-slider/assets/index.css';
import BoosterProperty from "../../components/booster-property/component";
import Footer from "../../components/footer/component";
import {scroller, Element} from 'react-scroll'
import * as moment from 'moment'
import DropdownTabs from "../../components/dropdown-tabs/component";
import CompareSellWithUs from "../../components/compare-sell-with-us/component";
import FaqSellWithUs from "../../components/faq-sell-with-us/component";
import DropdownSliderPrice from "../../components/dropdown-slider-price/component";
import Dropdown from "../../components/dropdown/component";
import YieldlockCalculatorSellToStay from "../../components/yieldlock-calculator-sell-to-stay/component";
import YieldlockCalculator from "../../components/yieldlock-calculator/component";
import YieldlockCalculatorSellToLet from "../../components/yieldlock-calculator-sell-to-let/component";

class SellWithUs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tab: {id: 1, title: "i want to sell-to-stay"},
            annual_rent: 0,
            confirmed_offer: 0,
            locking_years: {
                options: [
                    {id: 3, title: '3 Years', years: 3},
                    {id: 4, title: '4 Years', years: 4},
                    {id: 5, title: '5 Years', years: 5},
                    {id: 6, title: '6 Years', years: 6},
                    {id: 7, title: '7 Years', years: 7}
                ],
                placeholder: "Set term",
                value: JSON.stringify({id: 5, title: '5 Years', years: 5}),
                error: false
            },
            locking_yield: {
                options: [
                    {id: 3, title: '3% Yield', yield: 3},
                    {id: 4, title: '4% Yield', yield: 4},
                    {id: 5, title: '5% Yield', yield: 5},
                    {id: 6, title: '6% Yield', yield: 6},
                    {id: 7, title: '7% Yield', yield: 7}
                ],
                placeholder: "Select yield",
                value: '-1',
                error: false
            },
            types: {
                options: [
                    {id: 0, title: 'Sell-to-stay'},
                    {id: 1, title: 'Sell-to-let'}
                ],
                placeholder: "Set type",
                value: JSON.stringify({id: 0, title: 'Sell-to-stay'}),
                error: false
            },
            short_term: {
                options: [
                    {id: 0, title: 'Short-term eligible'},
                    {id: 1, title: 'Short-term not eligible'}
                ],
                placeholder: "Set eligibility",
                value: JSON.stringify({id: 0, title: 'Short-term eligible'}),
                error: false
            },
            init_yield: 3
        };
    };

    componentWillMount() {

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/sell');
            ReactGA4.send({ hitType: "pageview", page: "/sell" });
        }

    }

    functions = {};

    renderPropertyBooster() {
        try {
            return window.location.hostname.indexOf("propertybooster") !== -1
        } catch (e) {
            return false
        }
    }

    renderBoostaBostad(){
        try {
            return window.location.hostname.indexOf("boostabostad") !== -1
        }catch (e) {
            return false
        }
    }

    renderYieldlock(){
        try {
            return window.location.hostname.indexOf("yieldlock") !== -1
        }catch (e) {
            return false
        }
    }

    renderYieldspotter(){
        try {
            return window.location.hostname.indexOf("yieldspotter") !== -1
        }catch (e) {
            return false
        }
    }

    renderDropdownValue(item){
        try{
            return JSON.parse(item).id;
        }catch (e) {}
    }

    valid(){
        return this.state.types.value !== "-1" && this.state.locking_years.value !== "-1" && this.state.annual_rent > 0 && this.state.confirmed_offer > 0
    }

    render() {
        return (
            <div className={Styles.background}>
                <Element name="top" className="top"></Element>
                <BoosterHeader lang={this.props.match.params.lang} market={this.props.match.params.market} history={this.props.history}/>
                <div className={Styles.container}>
                    <div className={Styles.header}>
                        {
                            this.state.tab && this.state.tab.id === 1 &&
                        <div className={Styles.headerTitle}>
                            Sell your house <span className={Styles.headerTitleBold}>without moving out</span>
                        </div>
                        }
                        {
                            this.state.tab && this.state.tab.id === 2 &&
                            <div className={Styles.headerTitle}>
                                Sell your house <span className={Styles.headerTitleBold}>without losing rent</span>
                            </div>
                        }
                        {
                            this.state.tab && this.state.tab.id === 1 &&
                        <div className={Styles.headerSubtitle}>
                            ”release up to 85% equity and freeze your rent up to 7 years” ★★★★★
                        </div>
                        }
                        {
                            this.state.tab && this.state.tab.id === 2 &&
                            <div className={Styles.headerSubtitle}>
                                ”boost value up to 25% and earn rent up to 7 years” ★★★★★
                            </div>
                        }
                    </div>
                    <div className={Styles.containerInner}>
                        <div className={Styles.tabs}>
                            <DropdownTabs
                                options={[
                                        {id: 1, title: "i want to sell-to-stay"},
                                        {id: 2, title: "i want to sell-to-let"}
                                    ]}
                                value={this.state.tab}
                                onChange={(value) => {
                                    if(value.id === 1){
                                        this.state.types.value = JSON.stringify({id: 0, title: 'Sell-to-stay'});
                                    }else if(value.id === 2) {
                                        this.state.types.value = JSON.stringify({id: 1, title: 'Sell-to-let'});
                                    }
                                    this.setState({
                                        types: this.state.types,
                                        calculated: false,
                                        init_yield: 3,
                                        tab: value
                                    })
                                }}
                            />
                        </div>
                        {
                            this.state.tab && this.state.tab.id === 1 &&
                            <div className={Styles.tabsInfo}>
                                <div className={Styles.tabsInfoLeft}>
                                    <img className={Styles.tabsInfoLeftBackground} src={require("../../assets/images/YS_halo.png")}/>
                                    <img src={require('../../assets/images/YS_upto85equityrelease_Trans_EN.png')} className={Styles.tabsInfoLeftImage}/>
                                </div>
                                <div className={Styles.tabsInfoRight}>
                                    <div className={Styles.tabsInfoRightItem}>
                                        <div className={Styles.tabsInfoRightItemIcon}>+</div>
                                        <div className={Styles.tabsInfoRightItemTitle}>NO CREDIT SCORE OR INCOME</div>
                                        <div className={Styles.tabsInfoRightItemSubTitle}>perfect for expats and overseas owners</div>
                                    </div>
                                    <div className={Styles.tabsInfoRightItem}>
                                        <div className={Styles.tabsInfoRightItemIcon}>+</div>
                                        <div className={Styles.tabsInfoRightItemTitle}>FREEZE RENT UP TO 7 YEARS</div>
                                        <div className={Styles.tabsInfoRightItemSubTitle}>stay with complete peace of mind</div>
                                    </div>
                                    <div className={Styles.tabsInfoRightItem}>
                                        <div className={Styles.tabsInfoRightItemIcon}>+</div>
                                        <div className={Styles.tabsInfoRightItemTitle}>NO FINANCE CHARGES</div>
                                        <div className={Styles.tabsInfoRightItemSubTitle}>forget costly and unpredictable interest</div>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            this.state.tab && this.state.tab.id === 2 &&
                            <div className={Styles.tabsInfoSellToLet}>
                                <div className={Styles.tabsInfoRight}>
                                    <div className={Styles.tabsInfoRightItem}>
                                        <div className={Styles.tabsInfoRightItemIcon}>+</div>
                                        <div className={Styles.tabsInfoRightItemTitle}>BOOST VALUE</div>
                                        <div className={Styles.tabsInfoRightItemSubTitle}>get over market price</div>
                                    </div>
                                    <div className={Styles.tabsInfoRightItem}>
                                        <div className={Styles.tabsInfoRightItemIcon}>+</div>
                                        <div className={Styles.tabsInfoRightItemTitle}>INCOMES UP TO 7 YEARS</div>
                                        <div className={Styles.tabsInfoRightItemSubTitle}>earn rent after you sell</div>
                                    </div>
                                    <div className={Styles.tabsInfoRightItem}>
                                        <div className={Styles.tabsInfoRightItemIcon}>+</div>
                                        <div className={Styles.tabsInfoRightItemTitle}>SELL FASTER</div>
                                        <div className={Styles.tabsInfoRightItemSubTitle}>don’t sit around and take risk</div>
                                    </div>
                                </div>
                                <div className={Styles.tabsInfoLeft}>
                                    <img className={Styles.tabsInfoLeftBackground} src={require("../../assets/images/YS_halo.png")}/>
                                    <img src={require('../../assets/images/YS_upto25valueboost_Trans_EN.png')} className={Styles.tabsInfoRightImage}/>
                                </div>
                            </div>
                        }
                        <div className={Styles.tableInfo}>
                            <CompareSellWithUs
                                tab={this.state.tab}
                            />
                        </div>
                        <div className={Styles.contactAgent}>
                            <div className={Styles.contactAgentTitle}>
                                <div>
                                    Connect me to an <span className={Styles.contactAgentTitleBold}>agent...</span>
                                </div>
                                <div className={Styles.contactAgentSpace}></div>
                                <div className={Styles.contactAgentIcons}>
                                    <a href={"tel:" + "+971550000000"}>
                                    <div className={Styles.contactAgentIcon}>
                                        <img className={Styles.contactAgentIconPhone} src={require("../../assets/images/phone_icon_white.png")}/>
                                    </div>
                                    </a>
                                    <a href={"https://wa.me/" + "+971550000000" + "/?text=" + "Hey"}>
                                    <div className={Styles.contactAgentIcon}>
                                        <img className={Styles.contactAgentIconWhatsApp} src={require("../../assets/images/whatsapp_white.png")}/>
                                    </div>
                                    </a>
                                </div>
                            </div>
                            <div className={Styles.contactAgentInputs}>
                                <div className={Styles.contactAgentInputsItem}>
                                    <input placeholder={"First name*"} className={Styles.contactAgentInputsItemInput}/>
                                </div>
                                <div className={Styles.contactAgentInputsItem}>
                                    <input placeholder={"Last name*"} className={Styles.contactAgentInputsItemInput}/>
                                </div>
                                <div className={Styles.contactAgentInputsItem}>
                                    <input placeholder={"Email*"} className={Styles.contactAgentInputsItemInput}/>
                                </div>
                                <div className={Styles.contactAgentInputsItem}>
                                    <input placeholder={"Mobile*"} className={Styles.contactAgentInputsItemInput}/>
                                </div>
                            </div>
                            <div className={Styles.contactAgentButton}>
                                get pre-approved
                            </div>
                        </div>
                        <div className={Styles.convinced}>
                            Not<span className={Styles.convincedBold}>{" "}convinced?</span>
                        </div>
                        <div className={Styles.convincedSubtitle}>
                            <DropdownTabs
                                cursor={"default"}
                                options={
                                    [{id: 1, title: " Project your total value release"}
                                    ]}
                                value={{id: 1, title: " Project your total value release"}}
                                onChange={(value) => {

                                }}
                            />
                        </div>
                        <div className={Styles.convincedCalculator}>
                            <div className={Styles.convincedCalculatorType}>
                                <Dropdown
                                    options={this.state.types.options}
                                    error={this.state.types.error}
                                    placeholder={this.state.types.placeholder}
                                    value={this.state.types.value}
                                    disabled={this.state.calculated}
                                    onChange={(value) => {
                                        this.state.types.value = value;
                                        this.setState({
                                            types: this.state.types
                                        })
                                    }}
                                />
                            </div>
                            {
                                this.renderDropdownValue(this.state.types.value) === 1 &&
                                <div className={Styles.convincedCalculatorType}>
                                    <Dropdown
                                        options={this.state.short_term.options}
                                        error={this.state.short_term.error}
                                        placeholder={this.state.short_term.placeholder}
                                        value={this.state.short_term.value}
                                        disabled={this.state.calculated}
                                        onChange={(value) => {
                                            this.state.short_term.value = value;
                                            this.setState({
                                                short_term: this.state.short_term
                                            })
                                        }}
                                    />
                                </div>
                            }
                            <div className={Styles.convincedCalculatorYears}>
                                <Dropdown
                                    options={this.state.locking_years.options}
                                    error={this.state.locking_years.error}
                                    placeholder={this.state.locking_years.placeholder}
                                    value={this.state.locking_years.value}
                                    disabled={this.state.calculated}
                                    onChange={(value) => {
                                        this.state.locking_years.value = value;
                                        this.setState({
                                            locking_years: this.state.locking_years
                                        })
                                    }}
                                />
                            </div>
                            <div className={Styles.convincedSection}>
                                <div style={{color: '#00273A'} } className={Styles.convincedSectionTitle}>
                                    My latest annual rent
                                </div>
                                <DropdownSliderPrice
                                    error={this.state.error}
                                    currency={"AED"}
                                    disabled={this.state.calculated}
                                    value={this.state.annual_rent}
                                    max={10000000}
                                    onChange={(value) => {
                                        this.setState({
                                            annual_rent: value
                                        })
                                    }}
                                />
                            </div>
                            <div className={Styles.convincedSection}>
                                <div style={{color: '#00273A'} } className={Styles.convincedSectionTitle}>
                                    My latest confirmed offer
                                </div>
                                <DropdownSliderPrice
                                    error={this.state.error}
                                    currency={"AED"}
                                    disabled={this.state.calculated}
                                    value={this.state.confirmed_offer}
                                    max={100000000}
                                    onChange={(value) => {
                                        this.setState({
                                            confirmed_offer: value
                                        })
                                    }}
                                />
                            </div>
                            {
                                !this.state.calculated &&
                                <div onClick={() => {
                                    if(this.valid()){


                                        scroller.scrollTo('calculator', {
                                            duration: 200,
                                            delay: 0,
                                            offset: 0,
                                            smooth: 'easeInOutQuart'
                                        });

                                        //IF SELL TO STAY
                                        if(this.renderDropdownValue(this.state.types.value) === 0){

                                            this.state.list_price = this.state.confirmed_offer * 1.1;

                                            //CALCULATE YIELD
                                            let init_yield = this.state.annual_rent / this.state.list_price;
                                            init_yield = init_yield * 100;
                                            init_yield = Math.round(init_yield);

                                            this.setState({
                                                calculated: true,
                                                list_price: this.state.list_price,
                                                init_yield: init_yield
                                            }, () => {

                                            })
                                        }

                                        //IF SELL TO LET
                                        if(this.renderDropdownValue(this.state.types.value) === 1){

                                            let init_yield = 0;
                                            this.state.list_price = this.state.confirmed_offer * 1.1;

                                            //ELIGIBLE FOR SHORT-TERM
                                            if(this.renderDropdownValue(this.state.short_term.value) === 0){
                                                this.state.short_term_rent = this.state.annual_rent * 1.35;
                                                init_yield = this.state.annual_rent / this.state.list_price;
                                                init_yield = init_yield * 100;
                                                init_yield = Math.round(init_yield);
                                            }else{
                                                this.state.short_term_rent = this.state.annual_rent;
                                                init_yield = this.state.annual_rent / this.state.list_price;
                                                init_yield = init_yield * 100;
                                                init_yield = Math.round(init_yield);
                                            }

                                            this.setState({
                                                calculated: true,
                                                list_price: this.state.list_price,
                                                short_term_rent: this.state.short_term_rent,
                                                init_yield: init_yield
                                            }, () => {

                                            })

                                        }

                                    }
                                }} style={!this.valid()?{backgroundColor:"#888882", cursor: "not-allowed"}:{backgroundColor: "#00273A"}} className={Styles.convincedCalculatorButton}>
                                    calculate
                                </div>
                            }
                            {
                                this.state.calculated &&
                                <div onClick={() => {
                                    this.setState({
                                        calculated: false,
                                        init_yield: 3
                                    })
                                }} style={{backgroundColor: "#00273A"}} className={Styles.convincedCalculatorButton}>
                                    re-calculate
                                </div>
                            }
                            {
                                this.state.calculated &&
                                <div className={Styles.convincedArrow}>
                                    <img className={Styles.convincedArrowItem}
                                         src={require('../../assets/images/AB_arrow_down_orange.png')}/>
                                </div>
                            }
                            <Element name="calculator" className="calculator"></Element>
                            {
                                this.state.calculated && this.renderDropdownValue(this.state.types.value) === 1 &&
                                <div>
                                    <YieldlockCalculatorSellToLet
                                        years={this.renderDropdownValue(this.state.locking_years.value)}
                                        yield={this.state.init_yield}
                                        market_price={this.state.confirmed_offer}
                                        market_rent={this.state.annual_rent}
                                        list_price={this.state.list_price}
                                        list_rent={this.state.short_term_rent}
                                        up_front={false}
                                        updateUpfront={(value) => {

                                        }}
                                        updateListPrice={(value) => {

                                        }}
                                        updateYield={(value) => {

                                        }}
                                    />
                                </div>
                            }
                            {
                                this.state.calculated && this.renderDropdownValue(this.state.types.value) === 0 &&
                                <div>
                                    <YieldlockCalculatorSellToStay
                                        years={this.renderDropdownValue(this.state.locking_years.value)}
                                        yield={this.state.init_yield}
                                        market_price={this.state.confirmed_offer}
                                        market_rent={this.state.annual_rent}
                                        list_price={this.state.list_price}
                                        up_front={false}
                                        updateUpfront={(value) => {

                                        }}
                                        updateListPrice={(value) => {

                                        }}
                                        updateYield={(value) => {

                                        }}
                                    />
                                </div>
                            }
                        </div>
                        <div className={Styles.howDoesItWork}>
                            How does<span className={Styles.howDoesItWorkBold}>{" "}it work</span>
                        </div>
                        <div className={Styles.howDoesItWorkItems}>
                            <div className={Styles.howDoesItWorkItemsLeft}>
                                <div className={Styles.howDoesItWorkItemsLeftNumber}>
                                    1
                                </div>
                                <div className={Styles.howDoesItWorkItemsLeftContent}>
                                    <div className={Styles.howDoesItWorkItemsLeftContentTitle}>
                                        <div className={Styles.howDoesItWorkItemsLeftContentTitleBackground}>
                                            CONNECT WITH A CERTIFIED AGENT
                                        </div>
                                        <div className={Styles.howDoesItWorkItemsLeftContentTitleSpace}/>
                                    </div>
                                    <div className={Styles.howDoesItWorkItemsLeftContentSubtitle}>
                                        Get a dedicated agent all the way.
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.howDoesItWorkItemsRight}>
                                <div className={Styles.howDoesItWorkItemsRightNumber}>
                                    2
                                </div>
                                <div className={Styles.howDoesItWorkItemsLeftContent}>
                                    <div className={Styles.howDoesItWorkItemsLeftContentTitle}>
                                        {
                                            this.state.tab && this.state.tab.id === 1 &&
                                        <div className={Styles.howDoesItWorkItemsLeftContentTitleBackground}>
                                            DECIDE HOW LONG YOU WISH TO STAY
                                        </div>
                                        }
                                        {
                                            this.state.tab && this.state.tab.id === 2 &&
                                            <div className={Styles.howDoesItWorkItemsLeftContentTitleBackground}>
                                                DECIDE HOW LONG YOU WISH TO LET
                                            </div>
                                        }
                                        <div className={Styles.howDoesItWorkItemsLeftContentTitleSpace}/>
                                    </div>
                                    <div className={Styles.howDoesItWorkItemsLeftContentSubtitle}>
                                        Set your own terms and go to market.
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.howDoesItWorkItemsLeft}>
                                <div className={Styles.howDoesItWorkItemsLeftNumber}>
                                    3
                                </div>
                                <div className={Styles.howDoesItWorkItemsLeftContent}>
                                    <div className={Styles.howDoesItWorkItemsLeftContentTitle}>
                                        <div className={Styles.howDoesItWorkItemsLeftContentTitleBackground}>
                                            QUICKLY FIND BUYERS AND TRANSFER
                                        </div>
                                        <div className={Styles.howDoesItWorkItemsLeftContentTitleSpace}/>
                                    </div>
                                    {
                                        this.state.tab && this.state.tab.id === 1 &&
                                    <div className={Styles.howDoesItWorkItemsLeftContentSubtitle}>
                                        Release your equity and feel at home.
                                    </div>
                                    }
                                    {
                                        this.state.tab && this.state.tab.id === 2 &&
                                        <div className={Styles.howDoesItWorkItemsLeftContentSubtitle}>
                                            Release your equity and start earning.
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className={Styles.faqTitle}>
                            Any{" "}<span className={Styles.faqTitleBold}>questions?</span>
                        </div>
                        <div className={Styles.faqItems}>
                            <FaqSellWithUs
                                lang={this.props.match.params.lang}
                                tab={this.state.tab}
                            />
                        </div>
                    </div>
                </div>
                <div className={Styles.footer}>
                    <div className={Styles.footerInner}>
                        <div className={Styles.footerInnerItems}>
                            {
                                this.state.tab && this.state.tab.id === 1 &&
                                <div className={Styles.footerQuote}>
                                    ”Finally a way to release equity without costly obligations” ★★★★★
                                </div>
                            }
                            {
                                this.state.tab && this.state.tab.id === 2 &&
                                <div className={Styles.footerQuote}>
                                    ”Finally a way to cash out and boost resale value” ★★★★★
                                </div>
                            }
                            <img className={Styles.footerBadge} src={require("../../assets/images/YS_badgeInnovator.png")}/>
                        </div>
                    </div>
                    <img className={Styles.footerImageDesktop} src={require("../../assets/images/YS_skyline_Desktop_AE_B1_v2.jpg")}/>
                    <img className={Styles.footerImageMobile} src={require("../../assets/images/YS_skyline_Mobile_AE_B1_v2.jpg")}/>
                </div>
            </div>
        );
    }
}

export default SellWithUs;


// WEBPACK FOOTER //
// ./src/pages/sell-with-us/component.js